import { Controller } from "@hotwired/stimulus"

// Controller pour gérer le téléchargement ZIP avec feedback visuel
export default class extends Controller {
  static targets = ["text", "spinner"]

  download(event) {
    // Ne pas empêcher le comportement par défaut (téléchargement)

    // Changer le texte et afficher le spinner
    this.showLoading()

    // Remettre le texte normal après un délai
    // (le téléchargement se fait en arrière-plan)
    setTimeout(() => {
      this.hideLoading()
    }, 3000) // 3 secondes devraient suffire pour démarrer le téléchargement
  }

  showLoading() {
    if (this.hasTextTarget) {
      this.originalText = this.textTarget.textContent
      this.textTarget.textContent = "Préparation du ZIP..."
    }

    // Ajouter un spinner si on veut
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }

    // Désactiver le bouton
    this.element.classList.add("opacity-50", "cursor-not-allowed")
    this.element.setAttribute("disabled", "disabled")
  }

  hideLoading() {
    if (this.hasTextTarget && this.originalText) {
      this.textTarget.textContent = this.originalText
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }

    // Réactiver le bouton
    this.element.classList.remove("opacity-50", "cursor-not-allowed")
    this.element.removeAttribute("disabled")
  }
}